import { Coins, Layers, Percent, Flame, FileSearch } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { CA } from "@/config";
import { shortCa } from "@/lib/ca";
import { useLanguage } from "@/i18n/LanguageContext";

const CARDS = [
  { testid: "tokenomics-card-supply", icon: Coins, accent: "text-[#14F195]" },
  { testid: "tokenomics-card-network", icon: Layers, accent: "text-purple-300" },
  { testid: "tokenomics-card-tax", icon: Percent, accent: "text-[#14F195]" },
  { testid: "tokenomics-card-lp", icon: Flame, accent: "text-purple-300" },
  { testid: "tokenomics-card-ca", icon: FileSearch, accent: "text-[#14F195]" },
];

export const Tokenomics = () => {
  const { t } = useLanguage();
  return (
  <section id="tokenomics" className="scroll-mt-24 px-5 py-24 sm:px-8">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <Eyebrow>{t("tokenomics.eyebrow")}</Eyebrow>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display mt-5 text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
          {t("tokenomics.t1")} <span className="text-flow">{t("tokenomics.t2")}</span>
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-6">
        {CARDS.map((c, i) => (
          <Reveal
            key={c.testid}
            delay={0.08 * i}
            className={
              i === 0
                ? "md:col-span-4"
                : i === 1
                  ? "md:col-span-2"
                  : "md:col-span-2"
            }
          >
            <div
              data-testid={c.testid}
              className="group h-full rounded-3xl border border-purple-500/15 bg-[#0E0E16] p-6 transition-all hover:-translate-y-1 hover:border-[#14F195]/50 hover:shadow-[0_0_40px_rgba(153,69,255,0.15)] sm:p-7"
            >
              <div className="flex items-center justify-between">
                <c.icon size={22} className={`${c.accent}`} />
                <span className="font-display text-flow text-lg font-extrabold">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="font-display mt-6 text-xs font-bold uppercase tracking-[0.2em] text-gray-500">
                {t(`tokenomics.c${i + 1}t`)}
              </div>
              <div className="font-display text-flow mt-2 text-3xl font-extrabold tracking-tight sm:text-4xl">
                {i === 4 && CA ? shortCa() : t(`tokenomics.c${i + 1}v`)}
              </div>
              <div className="mt-2 text-sm text-gray-400">
                {t(`tokenomics.c${i + 1}s`)}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
